import { Field, Label, ErrorMessage } from "V2.0/common/fieldset";
import { Switch } from "V2.0/common/switch";
import InputComponent from "V2.0/components/InputComponent";

export default EvalRunConfigExpectedEventForm;

function EvalRunConfigExpectedEventForm(props) {
  const {
    formState,
    errors,
    updateFormState,
    personaOptions,
    eventsToTrackOptions,
  } = props;

  return (
    <div className="flex flex-col gap-y-4">
      <InputComponent
        type="select"
        label="Persona *"
        value={formState.persona}
        options={personaOptions}
        error={errors.persona}
        invalid={!!errors.persona}
        onChange={({ target: { value } }) => updateFormState("persona", value)}
      />

      <InputComponent
        type="select"
        label="Event *"
        value={formState.event}
        options={eventsToTrackOptions}
        error={errors.event}
        invalid={!!errors.event}
        onChange={({ target: { value } }) => updateFormState("event", value)}
      />

      <Field className="flex items-end gap-x-2">
        <Label>Expected</Label>
        <Switch
          color="emerald"
          checked={formState.expected}
          onChange={() => updateFormState("expected", !formState.expected)}
        />
      </Field>
    </div>
  );
}
